/**
 * @param {import('../constructionLog').ConstructionLog} constructionLog 
 */
export const fetchAttachedImages = constructionLog =>
  Promise.all(constructionLog.log_pages.map(page => {
    let paths = page.attached_file_paths
      .filter(str => !str.endsWith('.pdf'))
    return fetchImagesAsBase64WithDimensions(paths)
  }))

/**
 * Given paths to images, returns Promise with images in Base64 format.
 * @param {string[]} paths 
 */
export const fetchImagesAsBase64WithDimensions = paths =>
  Promise.all(paths.map(path => fetchImageAsBase64WithDimensions(path)))

export class ImageBase64WithDimensions {
  /**
   * @param {string} base64 
   * @param {number} width 
   * @param {number} height 
   */
  constructor (base64, width, height) {
    this.base64 = base64
    this.width = width
    this.height = height
  }
}

/**
 * @param {string} path 
 * @returns {Promise<ImageBase64WithDimensions>}
 */
export const fetchImageAsBase64WithDimensions = path =>
  fetch(path)
    .then(rawImage => rawImage.blob())
    .then(blob => convertBlobToBase64(blob))
    .then(imgBase64 => getImageWithDimensions(imgBase64))

/**
 * Given blob object, returns Promise with object in Base64 format.
 * @param {Blob} blob 
 * @returns {Promise<string>}
 */
const convertBlobToBase64 = blob => new Promise(
  (resolve, reject) => {
    const reader = new FileReader
    reader.onerror = reject
    reader.onload = () => {
      resolve('' + reader.result)
    }
    reader.readAsDataURL(blob)
  })

/**
 * @param {string} imgBase64 
 */
function getImageWithDimensions (imgBase64) {
  return new Promise(function (resolved) {
    let i = new Image()
    i.onload = function () {
      resolved(new ImageBase64WithDimensions(imgBase64, i.naturalWidth, i.naturalHeight))
    }
    i.src = imgBase64
  })
}